export default {
  dataIterator: {
    rowsPerPageText: '每页记录数：',
    rowsPerPageAll: '全部',
    pageText: '{0}-{1} 共 {2} 条',
    noResultsText: '没有找到匹配记录',
    nextPage: '下一页',
    prevPage: '上一页'
  },
  dataTable: {
    rowsPerPageText: '每页行数：'
  },
  noDataText: '没有数据',
  carousel: {
    prev: '上一页',
    next: '下一页'
  },
  errors: {
    codeIncorrect: '验证码不正确',
    errorLogin: '登录出错',
    qr: {
      notAllowed: '错误：您需要授予摄像头访问权限',
      notFound: '错误：此设备上未检测到摄像头',
      notSupported: '出错: 请在安全的登录环境试用(HTTPS)',
      notReadable: '出错: 摄像头是否已在使用中？',
      overConstrained: '出错: 摄像头不可用',
      streamAPINotSupported: '出错: 此浏览器不支持流媒体API',
      scanFailed: '无效二维码',
      tableNumberFailed: '无效桌号'
    },
    location: {
      inStoreTitle: '您当前的位置不在门店内',
      inStoreDescription: '抱歉，您当前的位置不在门店内，无法进行扫码点餐，请选择自取或者外卖',
      inStoreBtn: '确认',
      locationDisabledTitle: '需要允许手机定位功能',
      locationDescription: '请重新扫码，选择允许定位功能。或者在手机设置中打开定位',
      locationBtn: '确认'
    },
    cart: {
      menuUnavailable: '当前时段无法下单',
      startShopping: '开始购物'
    },
    schedule: {
      availableTimes: '{0}开放时间为 {1} - {2}',
      unavailableTimes: '{0} 不开放的时间段为 {1} - {2}',
      availableDay: '{0}将在 {1}{2}开放',
      unavailable: '{0}当前关闭，请尝试其他订单类型',
      startScheduling: '您可以在 {0}{1}后开始预订下单'
    },
    paymentUnsuccessful: '付款失敗',
    temporarilyAppear: '這筆費用可能會暫時顯示在您的對帳單上，然後再刪除',
    pageNotFound: '页面未找到',
    storeNotFoundMessage: '您要查找的商店未找到。它可能已被移动、删除或URL不正确。'
  },
  common: {
    today: '今天',
    nextAvailable: '下次可用',
    storeHoursClosedHoliday: '休息',
    referralButtonText: '邀請您的朋友',
    pointsEarned: '获得积分',
    confirmTitle: '请确认',
    confirmDesc: '您确定想要从堂食切换到自取下单？',
    actionText: '是的，切换',
    pickup: '自取',
    delivery: '配送',
    availableToDeliver: '可配送',
    notAvailableForDelivery: '不可配送',
    loginDescription: '立即注册或登录，解锁专属优惠券、奖励和为您量身定制的个性化优惠！',
    orderNow: '立即下单',
    hours: '营业时间',
    location: '门店地址',
    contact: '联系方式',
    socials: '社交媒体',
    snappyWhy: '为什么选择 Snappy',
    snappyBlog: '博客',
    snappyPricing: '价格',
    snappyDemo: '预约演示',
    snappyCaseStudies: '客户案例',
    clickToRedeem: '点击兑换',
    apply: '使用优惠券',
    order: '点餐',
    sortByDistance: '按距离排序',
    sortByAlpha: '按字母排序',
    searchLocations: '搜索地点',
    az: '字母',
    nearest: '最近',
    atLeast: '最少',
    to: '-',
    takeout: '外卖',
    or: '或者',
    guest: '直接下单',
    back: '后退',
    other: '其他',
    groups: '组别',
    options: '选项',
    edit: '自定义',
    register: '注册',
    poweredBy: 'POWERED BY',
    firstName: '名',
    lastName: '姓',
    phone: '电话',
    phoneNumber: '电话号码',
    address: '地址',
    storeHours: '营业时间',
    onlineOrderAvailableUntil: '网上订餐截止时间',
    mobileNumber: '手机号码',
    status: '状态',
    points: '积分',
    balance: '余额',
    save: '保存',
    changesSaved: '更改已保存',
    cancel: '取消',
    confirm: '确认',
    message: '信息',
    loadMore: '加载更多',
    loading: '加载中...',
    expires: '有效日期',
    login: '登入 / 注册',
    tweet: '发推',
    share: '分享',
    resend: '({0}秒后再次发送)',
    newCode: '新验证码',
    logout: '注销',
    fillFields: '请填写所有必填信息',
    invalidEmail: '电子邮箱格式错误',
    verify: '校验',
    continue: '继续',
    verifyCode: '验证码',
    sixDigitCode: '6位验证码',
    unlimited: '无上限',
    upTo: '最多',
    selected: '已选',
    items: '种',
    amount: '金额',
    scanQRCode: '请扫二维码',
    loadingQRScanner: '加载摄像头...',
    reloadQRScanner: '重新加载',
    open: '营业',
    open2: '正在营业',
    closed: '不营业',
    closed2: '休息中',
    email: '电子邮箱',
    select: '选择',
    ok: '确定',
    okConfirm: '确定',
    off: '折扣',
    app: {
      text1: '在',
      text2: 'App中打开',
      btn: '打开'
    },
    captcha: {
      main: '本网站受reCAPTCHA和Google保护',
      privacy: '隐私条款',
      and: '和',
      terms: '服务条款',
      apply: '适用。'
    },
    disclaimer: {
      main: '通过登录，我同意<link-tos>服务条款</link-tos>和<link-pp>隐私政策</link-pp>。我同意接收来自{businessName}的短信和其他数字通信，包括优惠券、特别优惠和促销活动。可能会产生标准短信和数据费用。',
      register: '请点击注册即表示您同意Snappy的<link-tos>服务条款</link-tos>与<link-pp>隐私政策</link-pp>。Snappy将使用短信进行账户安全验证和通知。您可随时取消短信服务。'
    },
    addedToCart: '已将“{0}”加入购物车',
    yourOrderId: '您的订单号是'
  },
  hours: {
    twentyFourHours: '全天营业',
    midNight: '午夜',
    mon: "星期一",
    tues: "星期二",
    wed: "星期三",
    thurs: "星期四",
    fri: "星期五",
    sat: "星期六",
    sun: "星期天",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期天"
  },
  menu: {
    specialRequests: '特殊要求',
    required: '必选',
    optional: '可选',
    soldOut: '已售罄',
    selectMenu: '请选择菜单',
    menuTitle: '菜单',
    promotionsAndRewards: '优惠与奖励',
    categories: '分类',
    noMenu:  '本店没有菜单',
    dropdown: '菜单下拉',
    unavailable: 'Menu unavailable',
    available: '下单时间',
    dayAvailable: 'Next available',
    availableOffHours: '支持提前下单',
    menuIsExclusive: '不同菜单中的产品不能加到同一购物车中',
    item: {
      onlyAvailable: '可用的',
      available: 'This item is only available from {0} - {1}',
      prepTime: '此商品通常需要约{0}来准备'
    },
    menuAvailability: '菜单可用性',
    gotIt: "知道了！",
    onlyAvailable: '此菜单仅在特定时间提供：',
    pricingBanner: '直接从 {2} 订购，与 {1} 相比平均可节省高达 {0}%'
  },
  cart: {
    title: '购物车',
    startShopping: '开始购物',
    continue: '继续',
    serviceFee: '服务费',
    takeOutOrder: '外带',
    backToLogin: '返回登录',
    enterYourAddress: '请输入您的地址',
    startAdding: '请添加您想要的商品',
    buildOrder: "请继续添加商品",
    currentlyClosed: '未到营业时间，请稍后再来',
    delivery: '配送',
    pickup: '自取',
    dinein: '堂食',
    estTimeHours: '小时',
    estTimeMins: '分钟',
    subtotal: '小计',
    deliveryFee: '配送费',
    tbd: '待定',
    deliveryMinimum: '配送最低消费',
    pickupMinimum: '自取最低消费',
    tax: '税',
    tip: '小费',
    rewards: '积分奖励',
    total: '总额',
    tipDriver: '配送司机小费',
    tipStore: '门店小费，感谢您的支持',
    btnCheckout: '确认订单',
    addToCart: '加入购物车',
    aiRecommendationsTitle: '为您推荐',
    aiRecommendationsTitleGuest: '推荐',
    aiRecommendationsSubtitle: '根据您的订单',
    aiRecommendationsSubtitleGuest: '本店热销',
    aiRecommendationsFrom: '起',
    clickToSee: '点击查看选项',
    saveCartItem: '更新购物车',
    payWithMembership: '会员卡支付',
    btnSubmitSubOrder: '发送订单',
    processing: '正在处理您的订单',
    pastOrders: '订单记录',
    discount: '折扣',
    closeModal: '关闭',
    btnPayOrder: '发送订单',
    cartUnavailable: '您的购物车中有些商品由于冲突或无效的可用性而无法订购',
    storeUnavailable: '暂时无法加入购物车',
    storeClosedBtn: '门店已打烊',
    offHourOrderingMaybeAllowed: '商店目前已关闭，但您仍然可以预约稍后的订单。',
    advanceBookingWindow: '商店已营业但暂未接受订单，您可以预约稍后的订单。',
    deliveryUnavailable: '目前无法配送',
    pickupUnavailable: '目前无法自取',
    tooSmallForDelivery: '未达到配送最低消费要求（最低消费：{0})',
    tooSmallForPickup: '订单金额過少，无法取货 (最低消费：{0})',
    invalidCoupon: '无效优惠券',
    cartErrors: '购物车错误',
    removeInvalidItemToContinue: '请移除该商品以继续。',
    discountNotUsed: '购物车不得为空',
    deliveryDisabled: '商家暂时不接受配送',
    pickupDisabled: '商家暂时不接受自取',
    deliveryDisabledUntil: '配送暂停接单，将在 {0} 重新开放',
    pickupDisabledUntil: '自取暂停接单，将在 {0}重新开放',
    asapClosed: '已打烊 · {0} {1}开始营业',
    asapPastCutoff: '今日已停止接单',
    asapSuspendedToday: '今日已停止接单',
    storeStoppedAcceptingOrders: '您结账时商家已停止接单。请选择一个预约时间以继续。'
  },
  account: {
    accountInfo: '账户信息',
    orderHistory: '历史记录',
    paymentMethods: '付款方式',
    contactInfo: '联系信息',
    membershipInfo: '会员信息',
    member: '会员',
    nonMember: '非会员',
    creditCard: '信用卡',
    nameOnCard: '姓名（请使用英文字母）',
    cardNumber: '卡号',
    expires: '有效日期',
    cvc: 'CVC',
    mmyy: '月/年',
    country: '信用卡所属国家',
    saveCard: '保存信用卡',
    addPaymentMethod: '添加信用卡',
    deliveryDetails: '配送详情',
    noOrderHistory: '没有历史记录',
    noPaymentMethods: '没有支付方式',
    addPaymentMethodPrompt: '请添加支付方式',
    noCreditCards: '没有支付方式',
    otherPostalCode: '非美国或加拿大卡，请任意输入',
    membership: '会员',
    history: '历史',
    payments: '付款',
    offline: '线下支付',
    orderId: '订单号',
    editTitle: '编辑個人信息',
    payment: {
      title: '删除信用卡',
      body: '您确定要删除此信用卡吗?',
      cancel: '取消',
      delete: '删除',
      status: {
        cvcFailed: '无效CVC',
        postalCodeFailed: '无效邮政编码',
        expiredCard: '卡已过期'
      }
    },
    rewards: {
      redeemFor: '兑换',
      rewardOptions: '兑换选项',
      coupons: '优惠券',
      punchCards: '打孔卡',
      using: '使用',
      remaining: '剩余',
      free: '免费',
      purchases: '已购买',
      redeem: '兑换',
      max: '上限',
      points: '积分',
      credits: 'Credits',
      discount: '折扣',
      yourPoints: '查看积分',
      creditsEarned: '获得{0}',
      worth: '价值',
      insufficientFunds: '积分不足',
      removeFirst: '无法添加，请移除当前兑换奖励',
      punchCardRibbon: '距离{2}还差{0}{1}！',
      selectItem: '选择商品',
      availableInCart: '请在购物车中兑换积分',
      availableInCartUpdated: '在购物车中兑换此优惠',
      alreadyInCart: '{0} 已在购物车中',
      missingPoints: '再积{0}分即可兑换免费礼品！',
      inEligible: '您无法使用此优惠券',
      noExpiration: '无过期时间',
      noLimitation: '无限制',
      buy1Get1Free: '买一送一',
      buy1Get1PercentOff: '买一第二件 {0}% 折扣',
      buy1Get1AmountOff: '买一第二件减 ${0}',
      validForSelectItems: '适用于特定商品',
      discountPercentOff: '折扣 {0}% 优惠',
      discountAmountOff: '折扣 {0}{1} 优惠',
      discountOff: '折扣 {0} 优惠',
      discountUpTo: '{0}，最高 {1}',
      maxDiscountReached: '已达到最高折扣 {0}',
      maxDiscountOf: '最高 {0}',
      maxDiscountOfDetail: '最高折扣 {0}',
      offerExpires: '优惠到期：{0}',
      loginPrompt: '请登录后查看积分',
      inPersonRedeemable: '此优惠只能在线下门店兑换',
      orderRewards: {
        congrats: '恭喜！',
        coupons: '您的订单获得了奖励优惠卷',
        lossFallback: '抱歉，这次没有中奖，下次再来一单！'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: '为您推荐',
    aiRecommendationsCategoryGuest: '推荐',
    deliveryProvider: {
      robot: '机器人',
      human: '司机',
      byRobot: '您的订单将由机器人配送！',
      byHuman: '您的订单将由司机配送',
      recommended: '商家推荐',
      notSupported: '您的地址不支持{0}配送', //where 0 is either Robot or Human
      deliveryInstructions: 'Please be aware, Robots cannot climb stairs. You will need to provide your emailed code in order to retrieve your food'
    },
    error: {
      empty: '这里什么都没显示!',
      noResults: '沒有返回結果.',
      tryAdjusting: '尝试调整你的过滤条件',
      clear: '清除搜索'
    }
  },
  order: {
    estimatedTime: '您的订单已经成功提交，大约{0}后可取',
    estimatedTimeDiff: '您的订单已经成功提交，大约{0}分钟后可取',
    successfulOrder: '您的订单已经成功提交',
    deliveryAddressInvalid: '您输入的地址信息无效，请重新输入',
    deliveryAddressMustBeSet: '请输入您的配送地址',
    deliveryAddressMustBeInRange: '对不起，您的地址不在配送范围内，请联系门店下单',
    noPaymentMethodSelected: '请选择支付方式',
    insufficientPoints: '会员充值余额不足',
    requiresAdditionalMethod: '会员余额不足，请添加第二种付款方式',
    cardMinimumCharge: '刷卡金额至少需 {0}。请添加小费或其他商品，或使用银行卡支付此订单。',
    minCardChargeNote: '最低刷卡金额 {0}',
    applyMembershipInstead: '改为使用 {0}',
    noPaymentMethods: '请选择付款方式',
    pickUpDetails: '自取详情',
    orderDetails: '订单详情',
    selectOrderType: '请选择订单类型',
    orderPlaced: '已发送订单',
    orderNotes: '订单备注',
    pickUpTime: '自取时间',
    pickUpDay: '自取日期',
    deliveryTime: '配送时间',
    deliveryDay: '配送日期',
    deliveryAddress: '配送地点',
    addressLine1: '地址栏第一行',
    addressLine2: '地址栏第二行',
    postalCode: '邮编',
    city: '城市',
    payment: '支付',
    placeOrder: '发送订单',
    personalDetails: '个人详情',
    tableNumberSet: '桌号扫码成功',
    onlyOffline: "本餐厅只接受线下支付",
    paidOffline: "请在线下进行支付",
    emailReceipt: "发送收据到我的邮箱",
    offlineEmailReceipt: "发送订单详情到我的邮箱",
  	orderScheduled: "预订时间",
    status: {
      new: '新订单',
      inProgress: '准备中',
      ready: '已准备好',
      cancelled: '已取消',
      refunded: '已退款',
      completed: '完成'
    },
    orderActions: {
      call: '致电',
      direction: '导航',
      orders: '查看订单',
      feedbackTitle: '请评价您的点餐体验',
      feedbackLabel: '请留下您的宝贵意见'
    }
  },
  iosBanner: {
    partOne: '点击分享图标',
    partTwo: '选择添加到主页',
    partThree: '保存页面'
  },
  checkoutSuccess: {
    text: '订单成功'
  },
  orderSubmitted: {
    text: '订单已提交'
  },
  deliveryDialog: {
    title: '配送详情',
    deliverAsap: '立即配送',
    schedule: '预约',
    update: '更新',
    selectAddress: '请输入您的地址',
    noDeliveryProviders: '该地址暂无配送服务',
    deliveryAddressSet: '配送地址已设置！',
    selectDateTime: '请选择有效的日期和时间',
    notAvailable: '抱歉，此选项不可用',
    pleaseSelectDate: '请选择日期'
  },
  orderDialog: {
    title: '取餐详情',
    deliveryTitle: '配送详情',
    pickUpAsap: '立即取餐',
    deliverAsap: '立即配送',
    schedule: '预约',
    done: '完成',
    selectDate: '请选择日期',
    notAvailable: '抱歉，此选项不可用',
    selectDateTime: '请选择有效的日期和时间',
    noAvailableDays: "没有可用的日期",
    earliestDate: "最早的日期已设置",
    staleTimeBodyGroup: "商店无法在{0}前准备好您的订单。请选择新时间以继续 — 您的小组和访客的商品不会改变。",
    staleTimeBodySolo: "商店无法在{0}前准备好您的订单。请选择新时间以继续。",
    confirmSlot: "确认 {0}",
    goBack: "返回"
  },
  storeLocation: {
    pickUpAt: '取餐',
    inStore: '店内',
    pickUpTime: '取餐时间',
    deliveryTime: '配送时间',
    time: '时间',
    deliverTo: '配送至',
    clickToSet: '点击设置'
  },
  orderTypes: {
    pickup: '自取',
    delivery: '配送',
    dineIn: '堂食'
  },
  groupOrder: {
    title: '拼单',
    namePlaceholder: '拼单名称',
    from: '来自',
    deliverTo: '配送至',
    pickupAt: '取餐地点',
    invitePeople: '邀请成员',
    chooseWhoPays: '选择付款方式',
    paySubtitle: '发起人（您）将支付整个拼单的费用。付款方式将在结账时填写。',
    youPayForEveryone: '由您代付',
    hostWillPayForEveryone: '主办人将代付',
    limitPlaceholder: '输入每人限额（可选）',
    perPerson: '每人',
    everyonePaysThemselves: '各自付款',
    comingSoon: '即将推出',
    next: '下一步',
    yourGroupOrderLink: '您的拼单链接',
    copy: '复制',
    share: '分享',
    linkCopied: '链接已复制！',
    join: '加入 {0} 的拼单',
    spendingLimit: '消费限额',
    limitNoLimit: '无限制',
    limitOther: '其他',
    joinGroupOrder: '加入拼单',
    joining: '正在加入...',
    loginToJoin: '登录后加入',
    continueAsGuest: '以访客身份继续',
    enterYourName: '请输入您的姓名',
    joinOrderDisclaimer: '点击"加入订单"即表示您同意',
    joinOrder: '加入订单',
    back: '返回',
    notSet: '未设置',
    cancelGroupOrder: '取消拼单',
    cancelGroupOrderConfirmTitle: '取消 {0}？',
    cancelGroupOrderConfirmBody: '这将结束所有人的拼单，所有参与者将被移除。',
    cancelGroupOrderConfirm: '是的，取消',
    cancelGroupOrderKeep: '保留拼单',
    cartMenuCancelGroup: '取消拼单',
    cartMenuLeaveGroup: '退出',
    cartMenuInvite: '邀请成员',
    lockedBannerGuest: '此拼单已锁定，如需修改请联系发起人。',
    lockedBannerHost: '您的购物车已锁定，仍可继续结账。',
    unlockMyCart: '解锁购物车',
    othersInGroup: '同组其他人（共 {0} 人）',
    othersHaveAdded: '{0} / {1} 人已添加商品',
    memberHostLabel: '（发起人）',
    memberReadyBadge: '已准备',
    memberWaitingBadge: '等待中',
    memberErrorBadge: '商品缺货',
    memberCartHasErrors: '您的小组中有人的商品缺货，请移除后再继续。',
    memberNoItems: '暂无商品',
    unlockMemberCart: '解锁 {0} 的购物车',
    removeMember: '移除 {0}',
    yourItems: '您的商品',
    leaveConfirmTitle: '退出此拼单？',
    leaveConfirmBody: '您的商品将被移除，发起人将收到您退出的通知。',
    leaveConfirmBtn: '退出',
    leaveConfirmKeep: '取消',
    removeConfirmTitle: '将 {0} 从拼单中移除？',
    removeConfirmBody: '{0} 的商品将被移除，他们将收到被移除的通知。',
    removeConfirmBtn: '移除 {0}',
    checkoutConfirmTitle: '大家都准备好了吗？',
    checkoutConfirmBody: '继续后，拼单将被锁定，所有人将无法再做修改。',
    unreadyConfirmTitleSingle: '{0}还在下单',
    unreadyConfirmTitleMulti: '{0}位成员还在下单',
    unreadyConfirmBody: '结账后将为所有人关闭订单。',
    unreadyConfirmWaitingOnPrefix: '正在等待',
    unreadyConfirmWaitingOnSuffix: '。',
    and: '和',
    andOthers: '和另外 {0} 人',
    checkoutWithCurrentBtn: '连同他们的购物车结账',
    checkoutWithCurrentSubtext: '订单将包含他们目前已添加的商品',
    removeCartsCheckoutBtn: '不含他们结账',
    removeCartsCheckoutSubtext: '他们的购物车和商品将从订单中移除',
    errorRemoveUnreadyCarts: '部分购物车移除失败，请重试。',
    groupCartEmpty: '请至少添加一件商品后再结账。',
    participantWaiting: '等待中...',
    notReadyCount: '还有 {0} 位参与者未准备好',
    goToCheckout: '前往结账',
    lockedInGroupOrder: '您正在拼单中——订单类型和时间无法更改。',
    checkoutProcessing: '处理中...',
    checkoutBackBtn: '返回',
    readyBtn: '已准备好！',
    readyHint: '发起人将为所有人下单。',
    readyStatus: '已准备好！',
    imReadyBtn: '我准备好了！',
    addItemsBtn: '添加商品',
    lockedCheckoutBtn: '拼单已锁定',
    lockedTimeoutBtn: '订单已锁定——时间到',
    exceedsLimit: '超出拼单限额',
    snackParticipantLeft: '{0} 已退出拼单。',
    errorMarkReady: '标记准备失败，请重试。',
    errorCartLocked: '发起人已锁定订单，您现在无法修改。',
    errorUnlockCart: '无法解锁购物车，请重试。',
    errorLockGroup: '锁定拼单失败，请重试。',
    errorLeaveGroup: '退出拼单失败，请重试。',
    errorCancelGroup: '取消拼单失败，请重试。',
    errorUnlockMember: '解锁购物车失败，请重试。',
    errorRemoveParticipant: '移除参与者失败，请重试。',
    dialogRemovedTitle: '您已被移除',
    dialogRemovedBody: '发起人已将您从此拼单中移除，您的商品已清空。',
    dialogLeftTitle: '您已退出 {0}',
    dialogLeftBody: '您的商品已清空。',
    dialogCancelledTitle: '拼单已取消',
    dialogCancelledBody: '发起人已取消此拼单。',
    dialogPaidTitle: '下单成功！',
    dialogPaidBody: '您的拼单已成功提交。',
    dialogRecoveredTitle: '您有一个进行中的拼单',
    dialogRecoveredHost: '您是发起人',
    dialogRecoveredGuest: '您是参与者',
    dialogRecoveredBtn: '继续',
    deadlineTitle: '设置截止时间',
    deadlineSubtitle: '大家需要在什么时候完成点餐？',
    deadlineDayLabel: '截止日期（日）',
    deadlineTimeLabel: '截止时间（时）',
    noDeadline: '无截止时间',
    noDeadlineSet: '未设置截止时间',
    deadlineSpecificTime: '特定时间',
    orderDeadline: '点餐截止时间',
    orderBeforeDeadline: '请在 {0} 前下单',
    peopleCanOrderAnytime: '大家可以随时点餐',
    notAvailableScheduled: '此预定时间不可用',
    deadlineNotAvailableNow: '配送时间设为立即时不可设置截止时间。',
    noAvailableDeadlineTimes: '没有可用的截止时间，请选择更晚的配送时间。',
    noSpendingLimit: '无消费限额',
    spendingLimitValue: '{0} 消费限额',
    dialogChangedTitle: '主持人已更新订单',
    dialogChangedToDelivery: '已更改为外卖配送',
    dialogChangedToPickup: '已更改为自取',
    dialogChangedTime: '时间已从 {0} 更改为 {1}',
    dialogChangedTimeSet: '预定时间设置为 {0}',
    dialogChangedTimeCleared: '预定时间已取消（尽快）',
    timeChangedLabel: '时间已更改',
    timeChangedToLabel: '时间更改为',
    confirmChangeToDelivery: '切换到外卖配送？',
    confirmChangeToPickup: '切换到自取？',
    confirmChangeTypeBody: '这将为组内所有人更新订单类型。',
    asap: '尽快',
    orderAsap: '立即下单',
    now: '现在',
    staleTimeTitle: '您选择的时间已无法使用',
    staleTimeNearestSlotLabel: '最接近的可用时间',
    staleTimeChooseAnother: '选择其他时间',
    errorResetSchedule: '更新时间失败，请重试。',
    errorUpdateSchedule: '更新时间失败，请重试。',
    errorUpdateScheduleConflict: '暂时无法更新，请查看后重试。',
    discountsAtCheckout: '结账时应用折扣',
    deliveryFeeAtCheckout: '结账时计算',
    feesCalculatedAtCheckout: '税费、服务费及折扣将在结账时计算',
    exceedsSpendingLimit: '此商品将超过发起人设定的消费上限。',
    cartFinalized: '您的拼单已完成，无法再添加商品。',
    noDeadlineSlots: '没有可用时段来设定截止时间。',
    errorUpdateDeadline: '无法更新截止时间，请重试。',
    deadlineUpdated: '订单截止时间已更新：{0}',
    deadlineRemoved: '订单截止时间已更新。',
    shareGroupOrder: '加入我的拼单！',
    memberLocked: '已锁定',
    snackParticipantLeftHost: '{0} 已退出拼单。',
    tooltipBadgeNew: '新功能',
    tooltipTitle: '拼单如何使用',
    tooltipScene1Caption: '从菜单页面发起拼单',
    tooltipScene2Caption: '设置截止时间——以及由谁付款',
    tooltipScene3Caption: '分享链接，或让朋友扫码加入',
    tooltipScene4Caption: '所有人加入同一个购物车，一次结账。',
    tooltipStartBtn: '发起拼单',
    tooltipGotItBtn: '知道了',
    tooltipDemoPeopleJoined: '{0} 人已加入',
    tooltipDemoDeadlineTimeExample: '7月10日周五 · 下午12:30',
    tooltipDemoPaySub: '你付款 · 每人限额 $15',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: '拼单购物车',
    tooltipDemoOneCheckout: '一次结账——你付款',
    sheetTitle: '拼单功能上线啦',
    sheetSubtitle: '一起点餐——共享一个购物车，一次结账。',
    sheetBullet1: '设置订单截止时间',
    sheetBullet2: '你付款——或设置消费限额',
    sheetBullet3: '通过链接或二维码邀请好友',
    sheetNotNowBtn: '暂不需要',
    showHowItWorks: '看看怎么用',
    hostSetsTip: '作为发起人，你来设置整个拼单的小费。',
    checkoutErrorGeneric: '结账失败，请重试。',
    checkoutErrorInvalidCart: '购物车中有部分商品需要处理后才能结账。',
    checkoutErrorOutOfStock: '部分商品已售罄，请移除后重试。',
    checkoutErrorMissingSelection: '请检查购物车中某个商品的选项。',
    checkoutErrorInvalidItem: '购物车中有一项商品已失效，请移除后重试。',
    checkoutErrorPaymentDeclined: '您的银行卡被拒绝，请尝试其他支付方式。',
    checkoutErrorPaymentFraud: '发卡机构拒绝了此支付方式，请尝试其他支付方式。',
    checkoutErrorCardDetails: '银行卡信息有误，请检查后重试。',
    checkoutErrorCardExpired: '此银行卡已过期，请尝试其他支付方式。',
    checkoutErrorPaymentGateway: '无法处理付款，请重试。',
    checkoutErrorNotOpen: '此拼单已不再开放。',
    checkoutErrorVersionConflict: '结账过程中拼单发生了变化，请检查后重试。',
    checkoutErrorInProgress: '结账正在处理中。',
    checkoutErrorEmpty: '拼单购物车为空。',
    checkoutErrorBlocked: '还有参与者尚未准备好。',
  },
  weChat: {
    warning: '请您退出页面，用微信扫码扫描二维码，谢谢',
    title: '请输入桌号'
  },
  checkout: {
    addCoupon: '添加优惠券',
    couponCode: '优惠券代码',
    title: '发送订单',
    description: '请确认下单',
    confirmCancel: '稍等',
    confirmApprove: '确认',
    onlinePay: '在线支付',
    weChatPay: '微信支付',
    unitNumber: '门牌号（选填）',
    primaryMethod: '支付',
    secondaryMethod: ' 第二种付款方式',
    credits: '账户余额',
    orderHints: '例如：任何忌口',
    deliveryHints: '例如：配送后请按门铃，请放在门廊，公寓buzz号码等',
    deliveryOptions: '配送说明',
    deliveryInstructions: '配送方式',
    orderDisposables: '需要一次性餐具、吸管等用品',
    deliveryDisposables: '请提供一次性餐具',
    disposablesIncluded: '如果您没有选择将不会提供',
    noPaymentMethods: '沒有可用的付款方式<br>请联系 {0}',
    billLoadError: '无法加载您的订单总额，请重试。',
    applePayFailed: '无法启动 Apple Pay，请重试或选择其他支付方式。',
    retry: '重试',
    confirmDialog: {
      total: '总',
      name: '门店名称',
      location: '门店地址',
      deliveryInfo: '配送信息',
      deliveryAddress: ' 配送地址',
      deliveryPhone: '配送电话',
      scheduled: '预约时间',
      pay: '支付',
      pickupTitle: '到店自取吗？',
      pickupBody: '请确认您将到店自取此订单。',
      pickupTime: '取餐时间：',
      beforeYouArrive: '到店前须知',
      yesPickUp: '是，我要取餐',
      goBack: '返回'
    },
    deliveryMessage: {
      leave_at_door: '放在门前',
      meet_at_door: '在门口见面',
      meet_outside: '在外面见面'
    },
    couponTypes: {
      title: '由于您使用了优惠券，此订单只能通过以下方式支付：',
      membership: '账户余额',
      online: '信用卡',
      wechat: '微信支付',
      offline: '线下支付'
    }
  },
  qr: {
    manulInput: '如无法扫码，请输入您的桌号',
    selectTable: '桌号',
    select: '确认'
  },
  apps: {
    giftcard: '礼品卡',
    coupons: '购买优惠券',
    deposit: '充值',
    lineup: '等候名单',
    reservation: '预约'
  },
  requestService: {
    openButton: '呼叫服务',
    title: '选择请求发送给服务员',
    sent: '请求已发送',
    login: '您需要在登录后使用此功能',
    tableNeeded: '请输入您的桌号以使用此功能'
  },
  sharedCart: {
    bannerLabel: '共享餐桌 · 桌号 #{0}',
    live: '实时',
    staleItemWarning: '其他顾客已更新 — 请确认后保存',
    sentToKitchen: '已送至厨房',
    roundSentToKitchen: '第 {0} 轮 · 已送至厨房',
    alreadyOrdered: '已点餐',
    itemCount: '{0} 项',
    stillOrdering: '正在加点',
    sending: '发送中...',
    reconnected: '已重新连接到共享餐桌 {0}。',
    joinedTitle: '您已加入餐桌！',
    joinedBody: '您现在正在与这里的所有人共享此餐桌的订单。',
    completedTitle: '餐桌订单已付款！',
    completedBody: '此餐桌的付款已完成，谢谢！',
    billAtPosTitle: '账单已发送至收银台',
    billAtPosBody: '您餐桌的账单已发送至收银台，请在那里付款以完成订单。',
    cancelledTitle: '餐桌会话已结束',
    cancelledBody: '此餐桌的共享购物车会话已过期，请扫描二维码开始新的会话。',
    roundFired: '菜品已发送到厨房。',
    errorFireRound: '发送到厨房失败，请重试。',
    errorItemChanged: '其他人已更改此商品 — 已刷新为最新版本，请重试。',
    errorMutateCart: '操作未成功，请重试。',
    errorSessionClosed: '此餐桌已关闭。',
    sharedTable: '共享餐桌',
    sharedTableActive: '● 共享餐桌进行中',
    tableLabel: '餐桌 {0}',
    errorStartSharedTable: '无法开始共享餐桌，请重试。',
  },
}
